// src/api/user.js
import request from '@/utils/request'

// 获取用户信息（余额实时，默认跳过接口缓存）
export function getUserInfo(options = {}) {
    return request({
        url: '/user/usersProfile/',
        method: 'get',
        skipApiCache: options.skipApiCache !== false,
        force: options.force === true,
    })
}

export function changeNameAuth(id, data) {
    return request({
        url: `/user/detail/${id}/changeRealName/`,
        method: 'post',
        data
    })
}

// 用户签到
export function sign() {
    return request({
        url: '/user/check-in/',
        method: 'post'
    })
}

export function getSignStatus() {
    return request({
        url: '/user/check-in/',
        method: 'get'
    })
}

export function realNameAuth(data) {
    return request({
        url: '/user/realNameAuth/',
        method: 'post',
        data
    })
}

export function getFundFlow(params) {
    return request({
        url: '/user/fundFlowList/',
        method: 'get',
        params
    })
}

// 获取推广奖励列表
export function getRewardList() {
    return request({
        url: '/user/referral/reward/list/',
        method: 'get'
    })
}

export function setUserBankCard(data) {
    return request({
        url: '/user/bankCard/',
        method: 'post',
        data
    })
}

export function getUserBankCard() {
    return request({
        url: '/user/bankCard/',
        method: 'get',
    })
}

export function delUserBankCard(data) {
    return request({
        url: `/user/bankCardDetail/${data.id}/`,
        method: 'delete',
        data
    })
}

export function editUserBankCard(data) {
    return request({
        url: `/user/bankCardDetail/${data.id}/`,
        method: 'put',
        data
    })
}

export function changeUserEmail(data) {
    return request({
        url: `/user/detail/${data.id}/changeEmail/`,
        method: 'post',
        data
    })
}

export function changeUserPassword(data) {
    return request({
        url: `/user/detail/${data.id}/changePassword/`,
        method: 'post',
        data
    })
}

export function changeUserPhoneNumber(data) {
    return request({
        url: `/user/detail/${data.id}/changePhoneNumber/`,
        method: 'post',
        data
    })
}

export function getUserPromotions(userId, level = 1, page = 1) {
    return request({
        url: `/user/detail/${userId}/getPromotions/`,
        method: 'get',
        params: {
            level,
            page
        }
    });
}

// 获取地址列表
export function getAddressList() {
    return request({
        url: '/user/addresses/',
        method: 'get'
    })
}

// 添加地址
export function addAddress(data) {
    return request({
        url: '/user/addresses/',
        method: 'post',
        data
    })
}

// 更新地址
export function updateAddress(id, data) {
    return request({
        url: `/user/addresses/${id}/`,
        method: 'put',
        data
    })
}

// 删除地址
export function deleteAddress(id) {
    return request({
        url: `/user/addresses/${id}/`,
        method: 'delete'
    })
}

// 获取提现记录
export function getWithdrawHistory(page = 1, pageSize = 10) {
    return request({
        url: '/user/withdraw/',
        method: 'get',
        params: {
            page,
            page_size: pageSize
        }
    })
}

// 提交提现申请
export function submitWithdraw(data) {
    return request({
        url: '/user/withdraw/',
        method: 'post',
        data,
        skipErrorDialog: true,
    })
}

// 绑定微信
export function setWechatAccount(data) {
    return request({
        url: `/user/detail/${data.user_id}/set_wechat_account/`,
        method: 'post',
        data
    })
}

// 绑定支付宝
export function setAlipayAccount(data) {
    return request({
        url: `/api/v1/user/detail/${data.user_id}/set_alipay_account/`,
        method: 'post',
        data: {
            alipay_account: data.alipay_account,
            alipay_name: data.alipay_name || '',
        }
    })
}

// 忘记密码
export function resetPassword(data) {
    return request({
        url: '/user/userInfo/forgotPassword/',
        method: 'post',
        data
    })
}

/** 征信修复：GET 进度；POST 提交（活动开始日后邀请满 1 人） */
export function getCreditRepair() {
    return request({
        url: '/user/credit-repair/',
        method: 'get',
        skipErrorDialog: true,
    })
}

export function submitCreditRepair() {
    return request({
        url: '/user/credit-repair/',
        method: 'post',
        skipErrorDialog: true,
    })
}

/** 现金红包状态 GET /user/cash-grab/ */
export function getCashGrabStatus() {
    return request({
        url: '/user/cash-grab/',
        method: 'get',
        skipErrorDialog: true,
    })
}

/** 现金红包领取 POST /user/cash-grab/ */
export function cashGrab(data = {}) {
    return request({
        url: '/user/cash-grab/',
        method: 'post',
        data,
        skipErrorDialog: true,
    })
}

/** 国际卡取款密码状态 GET /user/card-pin/ */
export function getCardPinStatus() {
    return request({
        url: '/user/card-pin/',
        method: 'get',
        skipErrorDialog: true,
    })
}

/** 获取取款密码短信验证码 POST /user/card-pin/sms/ */
export function sendCardPinSms(data = {}) {
    return request({
        url: '/user/card-pin/sms/',
        method: 'post',
        data,
        skipErrorDialog: true,
    })
}

/** 设置国际卡取款密码 POST /user/card-pin/ */
export function setCardPin(data = {}) {
    return request({
        url: '/user/card-pin/',
        method: 'post',
        data,
        skipErrorDialog: true,
    })
}

export function getUserLotteryRecords() {
    return request({
        url: '/api/v1/lottery/records/',
        method: 'get'
    })
}

// 添加中奖奖品邮寄地址
export function addPrizeAddress(data) {
    return request({
        url: `/api/v1/lottery/records/${data.id}/update_shipping_info/`,
        method: 'post',
        data
    })
}

